/**
 * 로그인 뒤 이동할 주소로 우리 사이트 안의 경로만 받는다.
 *
 * `?redirect=javascript:...` 를 그대로 `location.href` 에 넣으면 로그인하는 순간 우리 도메인에서
 * 스크립트가 실행돼 localStorage 의 토큰이 털린다. `//evil.com` 같은 외부 주소는 피싱 사이트로
 * 보내는 데 쓰인다. 문자열 비교 대신 브라우저와 같은 방식으로 해석해서 origin 을 비교한다.
 * (`/\t/evil.com` 처럼 브라우저가 공백을 지우면 `//evil.com` 이 되는 우회도 함께 막힌다.)
 */
export function toSafeRedirectPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/')) return undefined;

  const origin = window.location.origin;
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin) return undefined;

    // `/.//evil.com` 은 우리 origin 으로 해석되지만 정규화된 pathname 이 `//evil.com` 이 된다.
    // 돌려줄 값 자체를 다시 해석해서 그대로 우리 사이트를 가리킬 때만 내보낸다.
    const path = url.pathname + url.search + url.hash;
    if (path.startsWith('//') || path.startsWith('/\\')) return undefined;
    if (new URL(path, origin).origin === origin) return path;
  } catch {
    // 해석할 수 없는 값은 버린다.
  }
  return undefined;
}
